export class InvalidMainCouranteElementException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidMainCouranteElementException';
  }
}
